import { status } from '../../config.ts'
import { campaignPrizesPage1 } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/campaign-prizes?campaignId=1&limit=20',
    reply: async () => {
      await wait()
      return [status.ok, campaignPrizesPage1]
    }
  },
  {
    method: 'POST',
    path: '/campaign-prizes',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/campaign-prizes/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/campaign-prizes/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
